import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";
//import moment from "moment";

const slice = createSlice({
  name: "notification",
  initialState: {
    notification: [],
    pagination: {},
    loading: false,
    lastFetch: null,
  },
  reducers: {
    notificationRequested: (notification, action) => {
      notification.loading = true;
    },

    notificationReceived: (notification, action) => {
      notification.notification = action.payload.data;
      notification.pagination = action.payload.pagination;
      notification.loading = false;
      notification.lastFetch = Date.now();
    },

    notificationRequestFailed: (notification, action) => {
      notification.loading = false;
    },
  },
});

export const {
  notificationRequested,
  notificationReceived,
  notificationRequestFailed,
} = slice.actions;
export default slice.reducer;

// Action Creators
const url = "notification/";

export const loadAllNotification = (params) => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url,
      params,
      onStart: notificationRequested.type,
      onSuccess: notificationReceived.type,
      onError: notificationRequestFailed.type,
    })
  );
};
export const addNotification = (param, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      callback,
      url,
      method: "post",
      data: param,
    })
  );
};

export const getNotification = createSelector(
  (state) => state.entities.notification,
  (notification) => notification
);
